import { iI18nService } from './i18n.types';
import { iCookieService } from '../cookie/cookie.types';

export class I18nService implements iI18nService {
  constructor(private cookieService: iCookieService) {}

  changeLocale(locale: string): void {
    this.cookieService.set('locale', locale);
  }

  getLocale(): string {
    return this.cookieService.get('locale') || process.env.VUE_APP_I18N_LOCALE || 'en';
  }
}
